export default __webpack_public_path__ + "static/media/Casal Branco.f11c8459.png";